import i18n from "../../../../constants/i18n";
import getKhattabatSelectsStore from "../../../../stores/khattabat-stores/selects-store";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Date from "../../../../core/et3-input/et3-date";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const Form = withLiteObserverAndTheme(() => {
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={1510}
      height={100}
      color={""}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={700}
        height={100}
        color={""}
        style={{}}
        onClick={() => {}}
      >
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={getKhattabatSelectsStore().remunerationCycleFrom}
          isEnabled={true}
        />
        <Et3Margin top={0} bottom={0} right={30} left={0} />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={getKhattabatSelectsStore().remunerationCycleTo}
          isEnabled={true}
        />
      </ET3Div>
      <Et3Margin top={0} bottom={0} right={80} left={0} />

      <Et3Button
        isEnabled={true}
        onClick={async () => {
          await getKhattabatSelectsStore().getKhattabatRemunerationsDatabase();
        }}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </ET3Div>
  );
});

export default Form;
